angular.module('cimerFrontEndApp').controller('SearchBookBagsCtrl',
    ['$scope', '$location', 'Session', 'Discipline', 'InstitutionService', 'UserService', 'BookBagService',
function ($scope, $location, Session, Discipline, InstitutionService, UserService, BookBagService) {
    'use strict';
    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated || !sessionObject.isAdmin) {
        $location.url('/');
        return;
    }
  
    //Get discpline options
    Discipline.getDisciplines().then(function () {
        $scope.Disciplines = Discipline.disciplines;
    });

    $scope.SearchParameters = {
        User: null,
        Institution: null,
        Discipline: null,
        CreatedStartDate: null,
        CreatedEndDate: null
    };

    $scope.openStart = function () {
        $scope.startOpen = true;
    };

    $scope.openEnd = function () {
        $scope.endOpen = true;
    };

    $scope.Institution = {
        Loading: false,
        NoResults: false,
    };

    $scope.User = {
        Loading: false,
        NoResults: false
    };

    $scope.searchInstitution = function (text) {
        return InstitutionService.search(text).then(function (response) {
            return response.data;
        });
    };

    $scope.searchUsers = function (text) {
        return UserService.search(text).then(function (response) {
            return response.data;
        });
    };

    $scope.submitSearch = function () {
        $scope.searchSubmitted = true;

        if ($scope.search.$invalid) {
            return;
        }
        var userID = $scope.SearchParameters.User ? $scope.SearchParameters.User.ID : null;
        var institutionID = $scope.SearchParameters.Institution ? $scope.SearchParameters.Institution.ID : null;
        var disciplineID = $scope.SearchParameters.Discipline ? $scope.SearchParameters.Discipline.Value : null;

        BookBagService.searchBookBags(userID, institutionID, disciplineID, $scope.SearchParameters.CreatedStartDate, $scope.SearchParameters.CreatedEndDate).then(function (response) {
            $scope.searchResults = response.data;
        });

    };

}]);

//For use with the higherThan directive
angular.module('cimerFrontEndApp').directive("dateLowerThan", function ($filter) {
    'use strict';
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModelController) {
            //When the user enters text in the field
            ngModelController.$validators.lowerThan = function (value) {
                var maxValue = attrs.lowerThan;
                if (!value || !maxValue) { return true; }

                var maxDate = new Date(maxValue);

                var valid = (value <= maxDate);
                return (valid);
            };

            //When the minimum changes we're going to have to revalidate
            attrs.$observe("lowerThan", function (newMaxValue) {
                var value = scope.form.StartDate;
                if (!value || !newMaxValue) {
                    ngModelController.$setValidity("lowerThan", true);
                    return;
                }

                //the new max value comes in as a string and should be in the form of yyyy-MM-ddTHH:mmZ so we need to make a date object for comparison purposes
                var maxDate = new Date(newMaxValue);
                var valid = value <= maxDate;
                ngModelController.$setValidity("lowerThan", valid);
            });
        }
    };
});

//For use with lowerThan directive
angular.module('cimerFrontEndApp').directive("dateHigherThan", function () {
    'use strict';
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModelController) {
            //When user enters text in the field
            ngModelController.$validators.higherThan = function (value) {
                var minValue = attrs.higherThan;
                if (!value || !minValue) { return true; }

                var minDate = new Date(minValue);

                var valid = (value >= minDate);
                return (valid);
            };

            //When the maximum changes we're going to have to revalidate
            attrs.$observe("higherThan", function (newMinValue) {
                var value = scope.form.StartDate;
                if (!value || !newMinValue) {
                    ngModelController.$setValidity("higherThan", true);
                    return;
                }

                //the new min value comes in as a string and should be in the form of yyyy-MM-ddTHH:mmZ so we need to make a date object for comparison purposes
                var minDate = new Date(newMinValue);
                var valid = value >= minDate;
                ngModelController.$setValidity("higherThan", valid);
            });
        }
    };
});